import { useState, useEffect } from "react";
import { contact } from "../data/contact";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaYoutube,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa";
import { SiZalo } from "react-icons/si";

const ContactInfo = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    // Load static data thay vì gọi API
    setSettings(contact);
  }, []);

  if (!settings) return null;

  return (
    <div className="bg-white shadow-2xl rounded-3xl p-6 sm:p-8 mb-10 max-w-xl mx-auto border border-gray-300">
      <h2 className="text-2xl font-bold mb-6 text-red-600 text-center">
        Thông tin liên hệ
      </h2>

      <ul className="space-y-4 text-gray-700 text-base">
        {settings.phone && (
          <li className="flex items-center gap-3">
            <FaPhoneAlt className="text-red-500 text-xl" />
            <a
              href={`tel:${settings.phone}`}
              className="hover:text-red-600 transition"
            >
              {settings.phone}
            </a>
          </li>
        )}

        {settings.email && (
          <li className="flex items-center gap-3">
            <FaEnvelope className="text-red-500 text-xl" />
            <a
              href={`mailto:${settings.email}`}
              className="hover:text-red-600 transition"
            >
              <span className="md:hidden">Email</span>
              <span className="hidden md:inline">{settings.email}</span>
            </a>
          </li>
        )}

        {settings.address && (
          <li className="flex items-center gap-3">
            <FaMapMarkerAlt className="text-red-500 text-xl" />
            <a
              href="https://www.google.com/maps/place/10%C2%B053'51.8%22N+106%C2%B047'48.5%22E/@10.897708,106.7942384,17z/data=!3m1!4b1!4m7!1m2!10m1!1e2!3m3!8m2!3d10.897708!4d106.7968133?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-red-600 transition"
            >
              {settings.address}
            </a>
          </li>
        )}

        {settings.facebook_url && (
          <li className="flex items-center gap-3">
            <FaFacebook className="text-blue-600 text-xl" />
            <a
              href={settings.facebook_url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-600 transition"
            >
              <span className="md:hidden">Facebook</span>
              <span className="hidden md:inline">
                {settings.facebook_url}
              </span>
            </a>
          </li>
        )}

        {settings.zalo_url && (
          <li className="flex items-center gap-3">
            <SiZalo className="text-blue-500 text-xl" />
            <a
              href={settings.zalo_url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-600 transition"
            >
              <span className="md:hidden">Zalo-0786529313</span>
              <span className="hidden md:inline">{settings.zalo_url}</span>
            </a>
          </li>
        )}

        {settings.tiktok_url && (
          <li className="flex items-center gap-3">
            <FaTiktok className="text-xl" />
            <a
              href={settings.tiktok_url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-black"
            >
              <span className="md:hidden">TikTok</span>
              <span className="hidden md:inline">
                {settings.tiktok_url}
              </span>
            </a>
          </li>
        )}

        {settings.youtube_url && (
          <li className="flex items-center gap-3">
            <FaYoutube className="text-red-600" />
            <a
              href={settings.youtube_url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              YouTube
            </a>
          </li>
        )}

        {settings.instagram_url && (
          <li className="flex items-center gap-3">
            <FaInstagram className="text-pink-500" />
            <a
              href={settings.instagram_url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Instagram
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};

export default ContactInfo;